const saveBtnUtils = () => {
  const saveBtn = document.getElementById('saveButton');
  const isDirtyClass = 'dirty';

  const saveBtnAddClass = (newClass: string) => saveBtn?.classList.add(newClass);

  const saveBtnRemoveClass = (oldClass: string) => saveBtn?.classList.remove(oldClass);

  const isSaveBtnDirty = () => saveBtn?.classList.contains(isDirtyClass);

  const saveBtnToggleDirty = (toggleValue: boolean | undefined) => {
    const isDirty = isSaveBtnDirty();

    if (typeof toggleValue === 'boolean') {
      // true
      if (toggleValue) {
        if (!isDirty) {
          saveBtnAddClass(isDirtyClass);
        }
        return;
      }
      // false
      if (isDirty) {
        saveBtnRemoveClass(isDirtyClass);
      }
      return;
    }

    if (!isDirty) {
      saveBtnAddClass(isDirtyClass);
      return;
    }

    saveBtnRemoveClass(isDirtyClass);
  };

  const saveBtnOnClick = () => saveBtn?.click();

  const saveBtnAttachEvent = (eventHandler: any, event: string = 'click') =>
    saveBtn?.addEventListener(event, eventHandler, false);

  const saveBtnDetachEvent = (eventHandler: any, event: string = 'click') =>
    saveBtn?.removeEventListener(event, eventHandler, false);

  return {
    isSaveBtnDirty,
    saveBtn,
    saveBtnAddClass,
    saveBtnAttachEvent,
    saveBtnDetachEvent,
    saveBtnOnClick,
    saveBtnRemoveClass,
    saveBtnToggleDirty,
  };
};

export default saveBtnUtils;
